import { login, userInfo, logout } from '../services/login'
import { all, get } from '../services/restApi'
import { batchObject } from '../services/batch'
import { sendMail, createPassword } from '../utils'
import { parse } from 'qs'
import { message } from 'antd'
import moment from 'moment'
message.config({top: 61, duration: 3});

export default {
	namespace : 'app',
	state : {
		login: false,
		recoveryPassword: false,
		resetPassword: false,
		loading: false,
		loadingTable: false,
		user: {},
		currentHotel: JSON.parse(localStorage.getItem('currentHotel') || '{}'),
		buttonLoading: false,
		sidebarCollapse: document.body.clientWidth < 769,
		userMenuVisible: false,
		navOpenKeys: JSON.parse(localStorage.getItem('navOpenKeys') || '[]')
	},
	subscriptions : {
		setup({dispatch}) {
			dispatch({type: 'queryUser'})
		}
	},
	effects : {
		*login({payload}, {call, put, takeEvery}) {
			yield put({type: 'showButtonLoading'})

			try {

				const data = yield call(login, parse(payload))

				if (data.active) {

					if (data.type === 'administrador' || data.type === 'gerente' || data.type === 'recepcionista') {
						localStorage.setItem('currentUser', JSON.stringify(data));

						if (data.hotel) {
							const hotel = yield call(get, 'Hotel', data.hotel.objectId, {include: 'hotels'})
							localStorage.setItem('currentHotel', JSON.stringify(hotel));

							yield put({ type: 'loginSuccess', payload: {user: data, currentHotel: hotel} });
							
						} else {
							yield put({ type: 'loginSuccess', payload: {user: data} });
						}

					} else {
						message.error('Invalid username/password.')
						yield put({type: 'loginFail'})	
					}

				} else {
					message.error('Su cuenta ha sido temporalmente bloqueda')
					yield put({type: 'loginFail'})
				}

			} catch (e) {

				if (e && e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
				yield put({type: 'loginFail'})
			}
		},
		*logout({payload}, {call, put}) {
			yield put({type: 'showLoading'})

			try {

				if (localStorage.getItem('currentUser')) {

					const user = JSON.parse(localStorage.getItem('currentUser'));
					localStorage.removeItem('currentUser');
					localStorage.removeItem('currentHotel');

					yield call(logout, user.sessionToken)
					yield put({ type: 'logoutSuccess', payload: {user: {}} })
				}
			} catch (e) {
				yield put({ type: 'logoutSuccess', payload: {user: {}} })
			}

			yield put({type: 'hideLoading'})
		},
		*queryUser({payload}, {call, put}) {
			yield put({type: 'showLoading'})

			try {

				if (localStorage.getItem('currentUser') && JSON.parse(localStorage.getItem('currentUser')).objectId) {
					const user = JSON.parse(localStorage.getItem('currentUser'));
					yield put({ type: 'loginSuccess', payload: {user: user} });

					const data = yield call(userInfo, user.objectId)
					localStorage.setItem('currentUser', JSON.stringify(data));

					if (data.hotel) {
						const hotel = yield call(get, 'Hotel', data.hotel.objectId, {include: 'hotels'})
						yield put({ type: 'setCurrentHotelSuccess', payload: {currentHotel: hotel} });
					}
				}
			} catch (e) {
				if (e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
				yield put({type: 'loginFail'})
			}

			yield put({type: 'hideLoading'})
		},
		*recoveryPassword({payload}, {call, put}) {
			yield put({type: 'showButtonLoading'})

			try {

				// Consulta si el correo existe
				const resp = yield call(all, '_User', { where: payload })
				const user = resp.results[0]

				if (resp.results.length > 0) {

					// Model
					let data = {};
			        data.objectId = user.objectId;
			        data._method = "PUT";
			        data.token = yield call(createPassword, 42);
					data.tokenVigency = {__type: 'Date', iso: new Date(moment().add(2, 'days').format()).getTime()};

					// Guarda el token con vigencia
					yield call(batchObject, '_User', user.objectId, data)

					// Envía el email
					user.target = 'recoveryPassword'
					user.token = data.token
					yield call(sendMail, user)
					message.success('Le hemos enviado un correo electrónico con las instrucciones de recuperación')
					
				} else {
					message.error('El correo electrónico que ingresó no se encuentra registrado');
				}

			} catch (e) {
				if (e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'hideButtonLoading'})
		},
		*resetPassword({payload}, {call, put}) {
			yield put({type: 'showButtonLoading'})

			try {

				// Model
				let data = {};
		        data.objectId = payload.objectId;
		        data._method = "PUT";
		        data.token = null;
				data.tokenVigency = null;
				data.password = payload.password;

				// Actualizamos
				yield call(batchObject, '_User', payload.objectId, data)
				message.success('Se ha restablecido su contraseña con éxito')

				yield put({ type: 'handleLogin' })

			} catch (e) {
				if (e.data) message.error(e.data.error);
				else message.error('Ha ocurrido un error. Intente más tarde')
			}

			yield put({type: 'hideButtonLoading'})
		},
		*setCurrentHotel({payload}, {call, put}) {
			yield put({ type: 'setCurrentHotelSuccess', payload: {currentHotel: payload.currentHotel} });
		}
	},
	reducers : {
		loginSuccess(state, action) {
			return {
				...state,
				...action.payload,
				login: true,
				resetPassword: false,
				buttonLoading: false
			}
		},
		setCurrentHotelSuccess(state, action) {
			localStorage.setItem('currentHotel', JSON.stringify(action.payload.currentHotel));

			return {
				...state,
				...action.payload,
			}
		},
		loginFail(state) {
			return {
				...state,
				login: false,
				buttonLoading: false
			}
		},
		logoutSuccess(state) {
			return {
				...state,
				login: false
			}
		},
		showButtonLoading(state) {
			return {
				...state,
				buttonLoading: true
			}
		},
		hideButtonLoading(state) {
			return {
				...state,
				buttonLoading: false
			}
		},
		showLoading(state) {
			return {
				...state,
				loading: true
			}
		},
		hideLoading(state) {
			return {
				...state,
				loading: false
			}
		},
		showLoadingTable(state) {
			return {
				...state,
				loadingTable: true
			}
		},
		hideLoadingTable(state) {
			return {
				...state,
				loadingTable: false
			}
		},
		handleToggleMenu(state) {
			return {
				...state,
				sidebarCollapse: !state.sidebarCollapse
			}
		},
		handleToggleUserMenu(state, action) {
			return {
				...state,
				userMenuVisible: !state.userMenuVisible
			}
		},
		handleNavOpenKeys(state, action) {
			return {
				...state,
				...action.payload
			}
		},
		handleLogin(state) {
			return {
				...state,
				login: false,
				recoveryPassword: false
			}
		},
		handleRecoveryPassword(state) {
			return {
				...state,
				login: true,
				recoveryPassword: true
			}
		},
		handleResetPassword(state, action) {
			return {
				...state,
				...action.payload,
				resetPassword: true,
			}
		},
	}
}


// WEBPACK FOOTER //
// ./src/models/login.js